import { useEffect, useState } from "react"
import { get } from "../api/api"
import { formatDate, scoreTone } from "../utils/seo"

export default function Reports() {
  const [reports, setReports] = useState([])
  const [error, setError] = useState("")

  useEffect(() => {
    get("/reports")
      .then((res) => setReports(res.data))
      .catch((err) => setError(err.response?.data?.error || "Failed to load reports"))
  }, [])

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>SEO Reports</h1>
          <p className="muted">Saved audits from project and direct site runs.</p>
        </div>
      </div>

      {error && <p className="error">{error}</p>}

      <div className="card table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>Domain</th>
              <th>Health</th>
              <th>Authority</th>
              <th>Visibility</th>
              <th>Pages</th>
              <th>Issues</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {reports.map((report) => (
              <tr key={report._id}>
                <td>{report.domain}</td>
                <td>
                  <span className={`status ${scoreTone(report.score)}`}>{report.score}/100</span>
                </td>
                <td>{report.insights?.domainOverview?.authorityScore || 0}</td>
                <td>{report.insights?.domainOverview?.visibilityScore || 0}/100</td>
                <td>{report.crawl?.crawled || 0}</td>
                <td>
                  <span className="pill high">{report.insights?.criticalCount || 0} critical</span>{" "}
                  <span className="muted">{report.audit?.summary?.totalIssues || 0} total</span>
                </td>
                <td>{formatDate(report.createdAt)}</td>
              </tr>
            ))}
            {reports.length === 0 && (
              <tr>
                <td colSpan="7" className="muted">
                  No reports yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
